import React, { Component } from 'react'
import { Card, Col, Row, Form, Button, OverlayTrigger,Popover  } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import MainMenu from '../../components/menu/MainMenu';
import { changePassword } from '../../resources/API';
import SimpleModal from '../../components/modal/SimpleModal';
import LoadingModal from '../../components/modal/LoadingModal';
import { regEx } from '../../resources/Utils';

export default class ChangePassword extends Component {

  constructor(props) {
    super(props)
    this.state = {
      password: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      modal :{
        header : null,
        body : null,
        footer : null,
        show : false,
        variant : 'scb'
      },
      loadingShow : false
    }
  }

  onChange = (e) => {
    let { name, value } = e.target
    this.setState({ password: { ...this.state.password, [name]: value } })
  }

  changePassword = async () => {
    let { currentPassword, newPassword } = this.state.password;
    let { token } = this.props;
    this.setState({loadingShow:true});
    if(currentPassword === newPassword){
      this.setState({
        modal: {
                header : "Error",
                body : "New password cannot be the same as your current password.",
                footer : null,
                show : true,
                variant : 'danger'
            },
        loadingShow:false
      });
      return;
    }

    const changePasswordResponse = await changePassword(token, currentPassword, newPassword);
    this.setState({loadingShow:false});

    if(changePasswordResponse.status === 200) {
      const footer = <LinkContainer to="/" activeClassName="">
                      <Button variant="outline-secondary">Close</Button>
                  </LinkContainer>
      this.setState({
        modal: {
                header : "Notification",
                body : "Your password has been changed successfully. You will be redirected to home screen.",
                footer : footer,
                show : true,
                variant : 'scb',
                backdrop : 'static'
            }
      });
    } else {
      this.setState({
        modal: {
                header : "Error",
                body : "Password cannot be changed. Please try again.",
                footer : null,
                show : true,
                variant : 'danger'
            }
      });
    }
  }

  handleChangePassword = (e) => {
    e.preventDefault();
    let {username, isReset} = this.props;
    let { currentPassword, newPassword } = this.state.password;
    if(isReset) {
      this.props.onAuthen({username:username, password:currentPassword, newPassword:newPassword}, isReset);
    } else {
      this.changePassword();
    }
  }

  handleModalClose = async () => {    
    let modal = this.state.modal;
    modal.show = false;
    this.setState({
      modal: modal
    });
  }

  render() {
    let {isReset} = this.props;
    const {role} = this.props;
    let {loadingShow, modal} = this.state;
    let { currentPassword, newPassword, confirmPassword } = this.state.password;
    let errorMessage = "";
    let isFieldBlank = currentPassword === "" || newPassword === "" || confirmPassword ==="";

    if (confirmPassword!== "" && newPassword !== confirmPassword) {
        errorMessage = "Password does not match. Please try again.";
    }

    return (
      <React.Fragment>
        <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
          <Card.Body className="p-0 bg-grey">
            <MainMenu role={role}/>
            <Form onSubmit={this.handleChangePassword}>
              <Card className="shadow mt-4 mx-auto card-width-1200">
                <Card.Header className="pt-3 pb-2 bg-white">
                  <Row>
                    <Col className="font-weight-bold text-scb">Change Password</Col>
                  </Row>
                </Card.Header>
                <Card.Body>
                  <Row className="my-5">
                    <Col xs={{ span: 6, offset: 3 }} className="text-center font-weight-bold">
                      To change your password, please fill in the fields below
                  </Col>
                  </Row>
                  <Row className="my-3">
                    <InputPasswordGroup
                      title="Current password" name="currentPassword" value={currentPassword} onChange={this.onChange} />
                  </Row>
                  <Row className="my-3 mb-0">
                    <InputPasswordGroup title="New password" name="newPassword" value={newPassword} onChange={this.onChange} />
                    <Col sm={1} className="px-0">
                      <OverlayTrigger trigger="hover" placement="right" overlay={popover}>
                        <FontAwesomeIcon icon={faInfoCircle} className="mt-2 text-scb" />
                      </OverlayTrigger>
                    </Col>
                  </Row>
                  <Row className="mb-5">
                    <InputPasswordGroup title="Confirm new password" name="confirmPassword" value={confirmPassword} onChange={this.onChange} placeholder="Re-enter new password" />
                    <Col sm={{ span: 6, offset: 2 }}>
                      <Row>
                        <Col sm={{ span: 6, offset: 6 }}>
                          <Form.Text className="text-danger">{errorMessage}</Form.Text>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="mt-5 my-2">
                    <Col sm={3} className="mr-auto ml-3">
                      <Button block variant="outline-secondary" onClick={isReset ? () => this.props.onCancel(false): ()=>this.props.history.goBack()}>Discard change</Button>
                    </Col>
                    <Col sm={3} className="ml-auto mr-3">
                      <Button block
                        disabled={isFieldBlank || errorMessage!==""}  
                        variant="scb" 
                        type="submit"
                      >
                      Change Password
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Form>
          </Card.Body>
        </Card>
        <LoadingModal show={loadingShow} />
        <SimpleModal
          modal={modal}
          onClose={this.handleModalClose}
        />
      </React.Fragment>
    )
  }
}

const InputPasswordGroup = ({ title, name, placeholder, value, onChange }) => {
  return (
    <Col sm={{ span: 6, offset: 2 }}>
      <Form.Group as={Row} controlId={name}>
        <Form.Label column sm={6} className="px-0 text-right required">
          {title}
          </Form.Label>
        <Col sm={6}>
          <Form.Control 
          type="password" 
          name={name} 
          pattern={regEx.PASSWORD}
          maxLength="16"
          value={value} 
          onChange={onChange} 
          placeholder={placeholder || `Enter ${title.toLowerCase()}`} 
          required/>
        </Col>
      </Form.Group>
    </Col>
  )
}

const popover = (
  <Popover id="popover-basic">
      <p className="font-weight-bold mb-1">Your password must be have at least</p>
      <ul className="pl-4 mb-1">
          <li>8-16 characters long</li>
          <li>1 uppercase character</li>
          <li>1 lowercase character</li>
          <li>1 number</li>
          <li>1 special character <br/>(allow "!", "@", "#", "$", "&", "*")</li>
      </ul>
  </Popover>
);
